import React from 'react';
import {
    PopupContainer,
    PopupContent,
    PopupTitle,
    Title,
    Icon,
    Merge,
    PopUpImage,
    BackTitle
} from './Popup.styled';
import Close from 'src/assets/images/CloseProduct.svg';
import {
    updateNavBarPosition,
    updateContainerPosition,
    isMobileView,
    logErrorToConsole,
} from 'src/utils/util';
import { useSelector } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Popup = ({
    children,
    borderRadius,
    landscapeHeight,
    landscapeMarginTop,
    title,
    onClose,
    img,
    onClick,
    width,
    webWidth,
    webHeight,
    fontSize,
    hideIcon,
    margin,
    zIndex,
    overflow,
    textAlign,
    lineHeight,
    DeskFontSize,
    addProductSpecific = false,
    mobileWidth = false,
    imageMarginLeftDesktop = '',
    imageMarginLeftMobile = '',
    opacity = 1,
    imgRightToText,
    imgRightToTextMarginLeft,
    popupContentPadding,
    popupContentPaddingMobile,
    mobileWidthPercent,
    impersonationBackground,
    SignatureMargin,
    popHeight,
    contentTabHeight,
    contentWidth,
    shipAdressPopup,
    borderTopRightRadius,
    borderTopLeftRadius,
    mobileMargin,
    minHeight,
    iconWidth,
    
    height,
    paddingTop,
    mobileZIndex,
    position,
    top,
    isDelayPositionChange,
    fromMore,
    alignItemsMob,
    color,
    paddingRight,
    imgWidth,
    mobileBg,
    mbOverflowY,
    mobHeight,
    smalHeight,
    colortitle,
    backgroundColor,
    mbBackGround,
    emptyCartWidth,
    ipadwidth,
    portraitWidth,
    mobileWidthB33Popup,
    titleWidth,
    flexDirection,
    imgLeftToText,
    titleFontWeight,
    titleFontFamily,
    isFromPop,
    mbJustifyContent,
    mbMarginRight,
    LeftArrow,
    backToText,
    
    isEquityCart,
    isSurgeryCart
}) => {
    const updateUsageFixedPosition = () => {
        isMobileView() && updateContainerPosition('#UsageContainer', 'fixed');
    };
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    useEffectWithErrorLogging(() => {
        updateNavBarPosition('absolute');
        updateContainerPosition('#UsageContainer', 'unset');
        if (!fromMore) {
            return () => {
                updateNavBarPosition('fixed');
                if (isDelayPositionChange) {
                    setTimeout(() => {
                        try {
                        updateUsageFixedPosition();
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }, [1000]);
                } else {
                    updateUsageFixedPosition();
                }
            };
        }
    }, []);

    return (
        <div>
            <PopupContainer
                overflow={overflow}
                zIndex={zIndex}
                opacity={opacity}
                background={impersonationBackground}
                popHeight={popHeight}
                contentTabHeight={contentTabHeight}
                shipAdressPopup={shipAdressPopup}
                mobileZIndex={mobileZIndex}
                mbBackGround={mbBackGround}
                isFromPop={isFromPop}
            >
                <PopupContent
                    borderRadius={borderRadius}
                    landscapeHeight={landscapeHeight}
                    margin={margin}
                    addProductSpecific={addProductSpecific}
                    mobileWidth={mobileWidth}
                    mobileWidthPercent={mobileWidthPercent}
                    popupContentPadding={popupContentPadding}
                    popupContentPaddingMobile={popupContentPaddingMobile}
                    SignatureMargin={SignatureMargin}
                    popHeight={popHeight}
                    isFromPop={isFromPop}
                    contentWidth={contentWidth}
                    emptyCartWidth={emptyCartWidth}
                    ipadwidth={ipadwidth}
                    landscapeMarginTop={landscapeMarginTop}
                    portraitWidth={portraitWidth}
                    mobileWidthB33Popup={mobileWidthB33Popup}
                    contentTabHeight={contentTabHeight}
                    shipAdressPopup={shipAdressPopup}
                    borderTopRightRadius={borderTopRightRadius}
                    borderTopLeftRadius={borderTopLeftRadius}
                    mobileMargin={mobileMargin}
                    minHeight={minHeight}
                    mobileBg={mobileBg}
                    mobHeight={mobHeight}
                    mbOverflowY={mbOverflowY}
                    smalHeight={smalHeight}
                    id="popUpContent"
                    position={position}
                    top={top}
                    backgroundColor={backgroundColor}
                    flexDirection={flexDirection}
                >
                    {title && (
                        <PopupTitle color={color} fontFamily={titleFontFamily} mbJustifyContent={mbJustifyContent}>
                            {LeftArrow && (
                                <BackTitle fontSize="14px" onClick={onClick}>
                                    <img src={LeftArrow} alt="back" />
                                    {`${backToText} `}
                                </BackTitle>
                            )}
                            <Merge
                                width={width}
                                webHeight={webHeight}
                                webWidth={webWidth}
                                alignItemsMob={alignItemsMob}
                                mbMarginRight={mbMarginRight}
                            >
                                {img && (
                                    <PopUpImage
                                        marginLeftDesktop={imageMarginLeftDesktop}
                                        marginLeftMobile={imageMarginLeftMobile}
                                        img={img}
                                        height={height}
                                        paddingTop={paddingTop}
                                        paddingRight={paddingRight}
                                        width={imgWidth}
                                    />
                                )}
                                {imgLeftToText && (
                                    <PopUpImage
                                        marginLeftDesktop={imageMarginLeftDesktop}
                                        marginLeftMobile={imgRightToTextMarginLeft}
                                        img={imgLeftToText}
                                    />
                                )}
                                <Title
                                    fontSize={fontSize}
                                    textAlign={textAlign}
                                    lineHeight={lineHeight}
                                    DeskFontSize={DeskFontSize}
                                    color={colortitle}
                                    width={titleWidth}
                                    fontWeight={titleFontWeight}
                                >
                                    {title}
                                </Title>
                                {imgRightToText && (
                                    <PopUpImage
                                        marginLeftDesktop={imageMarginLeftDesktop}
                                        marginLeftMobile={imgRightToTextMarginLeft}
                                        img={imgRightToText}
                                        marginTop = {'-10px'}
                                    />
                                )}
                            </Merge>
                            {onClose ? (
                                <Icon
                                    id="popup-close-icon"
                                    onClick={onClose}
                                    mobilePath={Close}
                                    iconWidth={iconWidth}
                                    mbIconWidth={  isEquityCart || isSurgeryCart
                                           ? '30px' : '0px' 
                                           
                                    }
                                    mbIconMarginLeft={ isEquityCart || isSurgeryCart 
                                           ? '2%' : '0px'
                                           
                                    }
                                />
                            ) : (
                                <Icon
                                    id="popup-open-icon"
                                    onClick={onClick}
                                    mobilePath={Close}
                                    hideIcon={hideIcon}
                                
                                />
                            )}
                        </PopupTitle>
                    )}
                    {children}
                </PopupContent>
            </PopupContainer>
        </div>
    );
};

export default Popup;
